export const tourText = {
  aiAssistant: {
    title: 'Explore AI Tools',
    description: 'Create microlessons, assistants, and videos.',
  },
  homeWelcome: {
    title: 'Welcome to tapybl AI',
    description: 'Get started quickly with AI tools.',
  },
  microLessonsCard: {
    title: 'Generate Lessons',
    description: 'Create complete interactive microlessons.',
  },
};
